import {
	type OperatorValue,
	OPERATOR_EQUALS,
	OPERATOR_NOT_EQUALS,
	OPERATOR_WAS_NOT_IN,
	OPERATOR_IS,
	OPERATOR_WAS_NOT,
	OPERATOR_IN,
	OPERATOR_IS_NOT,
	OPERATOR_NOT_IN,
	OPERATOR_WAS_IN,
	OPERATOR_WAS,
} from '@atlaskit/jql-ast';

export const resolveOperator = ({
	operatorValue,
	isList,
}: {
	operatorValue: OperatorValue;
	isList: boolean;
}) => {
	switch (operatorValue) {
		case OPERATOR_EQUALS:
		case OPERATOR_IN:
		case OPERATOR_IS:
			return isList ? OPERATOR_IN : OPERATOR_EQUALS;
		case OPERATOR_NOT_EQUALS:
		case OPERATOR_NOT_IN:
		case OPERATOR_IS_NOT:
			return isList ? OPERATOR_NOT_IN : OPERATOR_NOT_EQUALS;
		case OPERATOR_WAS_NOT_IN:
		case OPERATOR_WAS_NOT:
			return isList ? OPERATOR_WAS_NOT_IN : OPERATOR_WAS_NOT;
		case OPERATOR_WAS:
		case OPERATOR_WAS_IN:
			return isList ? OPERATOR_WAS_IN : OPERATOR_WAS;
		default:
			return operatorValue;
	}
};
